import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

/**
 * GET
 */
export const GetTransferOrderVariantsRequestSchema = z.object({
  authorizationProfileId: z.string().nullish(),
});
export type GetTransferOrderVariantsRequest = z.infer<typeof GetTransferOrderVariantsRequestSchema>;

export const GetTransferOrderVariantsResponseSchema = z.array(
  z.object({
    transferOrderVariantId: z.string(),
    name: z.string(),
    authorizationProfileId: z.string(),
    branchId: z.string(),
  })
);
export type GetTransferOrderVariantsResponse = z.infer<
  typeof GetTransferOrderVariantsResponseSchema
>;

export const GetTransferOrderVariantRequestSchema = z.object({
  transferOrderVariantId: z.string(),
});
export type GetTransferOrderVariantRequest = z.infer<typeof GetTransferOrderVariantRequestSchema>;

export const GetTransferOrderVariantResponseSchema = z.object({
  name: z.string(),
  authorizationProfileId: z.string(),
  branchId: z.string(),
  docSeriesId: z.string(),
  printoutTemplateId: z.string().nullish(),
});
export type GetTransferOrderVariantResponse = z.infer<typeof GetTransferOrderVariantResponseSchema>;

/**
 * POST
 */
export const PostTransferOrderVariantRequestSchema = z.object({
  name: z.string(),
  authorizationProfileId: z.string(),
  docSeriesId: z.string(),
  printoutTemplateId: z.string().nullish(),
});
export type PostTransferOrderVariantRequest = z.infer<typeof PostTransferOrderVariantRequestSchema>;

export const PostTransferOrderVariantResponseSchema = z.object({
  transferOrderVariantId: z.string(),
});
export type PostTransferOrderVariantResponse = z.infer<
  typeof PostTransferOrderVariantResponseSchema
>;

/**
 * PATCH
 */
export const PatchTransferOrderVariantRequestSchema = z.object({
  transferOrderVariantId: z.string(),
  body: z.object({
    name: z.string(),
    authorizationProfileId: z.string(),
    docSeriesId: z.string(),
    printoutTemplateId: z.string().nullish(),
  }),
});
export type PatchTransferOrderVariantRequest = z.infer<
  typeof PatchTransferOrderVariantRequestSchema
>;

export const PatchTransferOrderVariantResponseSchema = BaseVoidResponseSchema;
export type PatchTransferOrderVariantResponse = z.infer<
  typeof PatchTransferOrderVariantResponseSchema
>;

/**
 * DELETE
 */
export const DeleteTransferOrderVariantRequestSchema = z.object({
  transferOrderVariantId: z.string(),
});
export type DeleteTransferOrderVariantRequest = z.infer<
  typeof DeleteTransferOrderVariantRequestSchema
>;

export const DeleteTransferOrderVariantResponseSchema = BaseVoidResponseSchema;
export type DeleteTransferOrderVariantResponse = z.infer<
  typeof DeleteTransferOrderVariantResponseSchema
>;
